/** GIF ve harici animasyonlar medya kütüphanesine eklenmez. */
export function isGifUrl(src: string): boolean {
  const s = src.trim().toLowerCase();
  return (
    s.startsWith('data:image/gif') ||
    s.includes('giphy.com') ||
    /\.gif(?:\?|#|$)/i.test(s)
  );
}

export function isGifFile(file: File): boolean {
  return file.type === 'image/gif' || /\.gif$/i.test(file.name);
}

export function shouldSkipMediaUpload(src: string): boolean {
  return isGifUrl(src);
}
